import React, { createContext, useEffect, useState } from "react";
import { readTracking } from "./tracking";

const STORAGE_KEY = "funnel_v2_form";

const INITIAL_DATA = {
  leadId: null,
  createdAt: null,
  lastCompletedLeadId: null,
  tracking: null,
  step1: {},
  step2: {},
  step3: {},
  step4: {},
  step5: {},
  step6: {}
};

export const FunnelContext = createContext(null);

export function FunnelProvider({ children }) {
  const [data, setData] = useState(() => {
    // Capture attribution fresh on every page load (non-sticky): restore
    // everything else from localStorage, but always overwrite tracking from
    // the current URL + referrer.
    const fresh = readTracking();
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const base = raw ? { ...INITIAL_DATA, ...JSON.parse(raw) } : INITIAL_DATA;
      return { ...base, tracking: fresh };
    } catch {
      return { ...INITIAL_DATA, tracking: fresh };
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {}
  }, [data]);

  const update = (stepKey, patch) => {
    setData((prev) => ({
      ...prev,
      [stepKey]: { ...prev[stepKey], ...patch }
    }));
  };

  const setLead = (leadId, createdAt) => {
    // Starting a new lead: clear stale completion state from any prior run so
    // Step 6 fires /complete again for this fresh lead.
    setData((prev) => ({
      ...prev,
      leadId,
      createdAt,
      step5: {},
      step6: {},
      lastCompletedLeadId: null
    }));
  };

  const markCompleted = (leadId) => {
    setData((prev) => ({
      ...prev,
      lastCompletedLeadId: leadId,
      step6: { ...prev.step6, completedAt: new Date().toISOString() }
    }));
  };

  const reset = () => {
    setData(INITIAL_DATA);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
  };

  return (
    <FunnelContext.Provider value={{ data, update, setLead, markCompleted, reset }}>
      {children}
    </FunnelContext.Provider>
  );
}
